import { render } from "./EmergencyEquipmentDetail.vue?vue&type=template&id=1a6ffb23&scoped=true"
import script from "./EmergencyEquipmentDetail.vue?vue&type=script&lang=js"
export * from "./EmergencyEquipmentDetail.vue?vue&type=script&lang=js"

import "./EmergencyEquipmentDetail.vue?vue&type=style&index=0&id=1a6ffb23&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6ffb23"]])

export default __exports__